import React, { useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { useAppSelector } from "../store";
import { selectUserOwner } from "../store/user-owner/user-owner.selector";
import { LabAccount } from "../store/user-owner/user-owner.model";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import FindAccountNumberModal from "./modals/FindAccountNumberModal";

ModuleRegistry.registerModules([AllCommunityModule]);
library.add(faQuestionCircle);

const columns = [
  {
    field: "locationName",
    headerName: "ECP Location",
    flex: 0,
    wrapText: true,
    autoHeight: true,
    filter: "agTextColumnFilter",
    cellRenderer: (params: any) => {
      const location = params.value as string;
      return location.replace("Geo - ", "");
    },
  },
  {
    field: "address1", // Keep the field reference for sorting/filtering
    headerName: "Address",
    flex: 1,
    minWidth: 200,
    wrapText: true,
    autoHeight: true,
    filter: "agTextColumnFilter",
    cellRenderer: (params: any) => {
      const rowData = params.data;

      // First line: address1 + shippingStreet2
      const line1Parts = [rowData.address1, rowData.shippingStreet2].filter(Boolean);
      const line1 = line1Parts.join(' ');

      // Second line: city, state zip
      const line2Parts = [];
      if (rowData.shippingCity) line2Parts.push(rowData.shippingCity);
      if (rowData.shippingState) {
        const stateZip = [rowData.shippingState, rowData.shippingPostalCode].filter(Boolean).join(' ');
        line2Parts.push(stateZip);
      } else if (rowData.shippingPostalCode) {
        line2Parts.push(rowData.shippingPostalCode);
      }
      const line2 = line2Parts.join(', ');

      return (
        <>
          {line1 && <>{line1}</>}
          {line1 && line2 && <br />}
          {line2 && <>{line2}</>}
        </>
      );
    },
  },
  {
    field: "labAccounts",
    headerName: "Lab",
    flex: 1,
    wrapText: true,
    autoHeight: true,
    filter: "agTextColumnFilter",
    cellRenderer: (params: any) => {
      const accounts = params.value as LabAccount[];
      // For React, return a JSX fragment with line breaks
      return (
        <>
          {accounts.map((account, index) => (
            <React.Fragment key={account.memberID}>
              {`${account.opticalLabName}`}
              {index < accounts.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      );
    },
  },
  // {
  //   field: "labAccounts",
  //   headerName: "Lab Code",
  //   wrapText: true,
  //   autoHeight: true,
  //   minWidth: 125,
  //   maxWidth: 125,
  //   filter: "agTextColumnFilter",
  //   cellRenderer: (params: any) => {
  //     const accounts = params.value as LabAccount[];
  //     // return accounts[0].opticalLabID;
  //     // For React, return a JSX fragment with line breaks
  //     return (
  //       <>
  //         {accounts.map((account, index) => (
  //           <React.Fragment key={account.opticalLabID}>
  //             {`${account.opticalLabID.slice(4)}`}
  //             {index < accounts.length - 1 && <br />}
  //           </React.Fragment>
  //         ))}
  //       </>
  //     );
  //   },
  // },
  // {
  //   field: "labAccounts",
  //   headerName: "Account Number",
  //   filter: "agTextColumnFilter",
  //   wrapText: true,
  //   autoHeight: true,
  //   cellRenderer: (params: any) => {
  //     const accounts = params.value as LabAccount[];
  //     // For React, return a JSX fragment with line breaks
  //     return (
  //       <>
  //         {accounts.map((account, index) => (
  //           <React.Fragment key={account.memberID}>
  //             {`${account.memberID.slice(4)}`}
  //             {index < accounts.length - 1 && <br />}
  //           </React.Fragment>
  //         ))}
  //       </>
  //     );
  //   },
  // },
];
export default function LocationListModal() {
  const owner = useAppSelector(selectUserOwner);
  const gridRef = useRef<any>(null);
  const [showFindAccountNumberModal, setShowFindAccountNumberModal] =
    useState(false);

  return (
    <>
      <div className="flex justify-end mb-2">
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-top">
              Click to know how to find your account number.
            </Tooltip>
          }
        >
          <FontAwesomeIcon
            onClick={() => setShowFindAccountNumberModal(true)}
            className="cursor-pointer w-6 h-6"
            color="#0042c3"
            fill="#FFF"
            icon="question-circle"
          />
        </OverlayTrigger>
      </div>
      <div
        className="location-list-container"
        style={{ height: "100%", width: "100%" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={(owner?.labLocations || []) as any[]}
          columnDefs={columns}
          onGridReady={(event) => event.api.sizeColumnsToFit()}
          enableCellTextSelection={true}
          domLayout="autoHeight"
          suppressDragLeaveHidesColumns={true}
          suppressMovableColumns={true}
        />
      </div>
      <FindAccountNumberModal
        show={showFindAccountNumberModal}
        handleClose={() => setShowFindAccountNumberModal(false)}
      />
    </>
  );
}
